import { ApiService } from '~/services/api/api'

export interface GradeMultipleRequest {
  testAttemptIds?: string[]
  excludedIds?: string[]
  isAllSelected: boolean
  regrade: boolean
  excludeEdited?: boolean
  query?: string
  fileSubmissionStatus?: string
  gradingStatus?: string
  groupIds?: string
  flags?: string
  gradeMin?: number
  gradeMax?: number
}

export interface GradeMultipleResponse {
  successfulCount: number
  failedCount: number
  totalCount: number
  ignoredCount: number
  eligibleCount: number
}

export interface GradingEligibilityRequest
  extends Omit<GradeMultipleRequest, 'regrade' | 'excludeEdited'> {}

export interface GradingEligibilityResponse {
  notEligible: string[]
  eligible: string[]
  regradeEligible: string[]
  total: number
  edited: string[]
}

export class TestSubmissionGradingService {
  private readonly apiService = new ApiService()

  async batchRequestTestAttemptGrades(
    testId: string,
    request: GradeMultipleRequest,
  ) {
    const response = await this.apiService.post<
      GradeMultipleResponse,
      GradeMultipleRequest
    >(`/tests/${testId}/attempts/grade-multiple`, request)
    return response
  }

  async getGradingEligibility(
    testId: string,
    request: GradingEligibilityRequest,
  ) {
    const response = await this.apiService.get<GradingEligibilityResponse>(
      `/tests/${testId}/attempts/grading-eligibility`,
      {
        params: {
          query: request.query,
          isAllSelected: request.isAllSelected,
          excludedIds: request.excludedIds,
          testAttemptIds: request.testAttemptIds,
          fileSubmissionStatus: request.fileSubmissionStatus,
          gradingStatus: request.gradingStatus,
          groupIds: request.groupIds,
          flags: request.flags,
          gradeMin: request.gradeMin,
          gradeMax: request.gradeMax,
        },
      },
    )
    return response
  }
}
